module.exports = __webpack_public_path__ + "bin-file/default.svg";